export enum OPDServicesActionTypes {
    API_RESPONSE_SUCCESS = '@@opdServices/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR = '@@opdServices/API_RESPONSE_ERROR',

    ADD_OPD_SERVICE = '@@opdServices/ADD_OPD_SERVICE',
    EDIT_OPD_SERVICE = '@@opdServices/EDIT_OPD_SERVICE',
    GET_OPD_SERVICES = '@@opdServices/GET_OPD_SERVICES',
    GET_OPD_SERVICE = '@@opdServices/GET_OPD_SERVICE',
    GET_SERVICES_DROPDOWN = '@@opdServices/GET_SERVICES_DROPDOWN',
    DELETE_OPD_SERVICE = '@@opdServices/DELETE_OPD_SERVICE',
    RESET = '@@opdServices/RESET',
    RESET_SUCCESS = '@@opdServices/RESET_SUCCESS',
    RESET_ERROR = '@@opdServices/RESET_ERROR',
}
